// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Uuid from "uuid";
import * as Curry from "../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as Belt_Option from "../../../../node_modules/rescript/lib/es6/belt_Option.js";
import * as Caml_option from "../../../../node_modules/rescript/lib/es6/caml_option.js";
import * as Json_decode from "../../../../node_modules/@glennsl/bs-json/src/Json_decode.bs.js";
import * as Client from "@apollo/client";
import * as ApolloClient__React_Hooks_UseMutation from "../../../../node_modules/rescript-apollo-client/src/@apollo/client/react/hooks/ApolloClient__React_Hooks_UseMutation.bs.js";
import * as MutationHook$LiteracyplanetClientFlags from "../../../../node_modules/@literacyplanet/client-flags/src/MutationHook.bs.js";

var Raw = {};

var query = Client.gql(["mutation UpsertActivityState($state: String, $studentActivityAttemptId: uuid)  {\ninsert_student_activity_states_one(object: {state: $state, studentAttemptId: $studentActivityAttemptId}, on_conflict: {constraint: student_activity_states_pkey, update_columns: [state]})  {\n__typename  \nstate  \n}\n\n}\n"]);

function parse(value) {
  var value$1 = value.insert_student_activity_states_one;
  return {
          insert_student_activity_states_one: !(value$1 == null) ? ({
                __typename: value$1.__typename,
                state: value$1.state
              }) : undefined
        };
}

function serialize(value) {
  var value$1 = value.insert_student_activity_states_one;
  var insert_student_activity_states_one;
  if (value$1 !== undefined) {
    var value$2 = value$1.state;
    var value$3 = value$1.__typename;
    insert_student_activity_states_one = {
      __typename: value$3,
      state: value$2
    };
  } else {
    insert_student_activity_states_one = null;
  }
  return {
          insert_student_activity_states_one: insert_student_activity_states_one
        };
}

function serializeVariables(inp) {
  var a = inp.state;
  var a$1 = inp.studentActivityAttemptId;
  return {
          state: a !== undefined ? a : undefined,
          studentActivityAttemptId: a$1 !== undefined ? Caml_option.valFromOption(a$1) : undefined
        };
}

function makeVariables(state, studentActivityAttemptId, param) {
  return {
          state: state,
          studentActivityAttemptId: studentActivityAttemptId
        };
}

function makeDefaultVariables(param) {
  return {
          state: undefined,
          studentActivityAttemptId: undefined
        };
}

var ActivityStateMutation_inner = {
  Raw: Raw,
  query: query,
  parse: parse,
  serialize: serialize,
  serializeVariables: serializeVariables,
  makeVariables: makeVariables,
  makeDefaultVariables: makeDefaultVariables
};

var include = ApolloClient__React_Hooks_UseMutation.Extend({
      query: query,
      Raw: Raw,
      parse: parse,
      serialize: serialize,
      serializeVariables: serializeVariables
    });

var use = include.use;

var ActivityStateMutation_useWithVariables = include.useWithVariables;

var ActivityStateMutation = {
  ActivityStateMutation_inner: ActivityStateMutation_inner,
  Raw: Raw,
  query: query,
  parse: parse,
  serialize: serialize,
  serializeVariables: serializeVariables,
  makeVariables: makeVariables,
  makeDefaultVariables: makeDefaultVariables,
  use: use,
  useWithVariables: ActivityStateMutation_useWithVariables
};

var ActivityState = MutationHook$LiteracyplanetClientFlags.Make({
      Raw: Raw,
      use: use
    });

function useUpsertActivityState(param) {
  var match = Curry._1(ActivityState.useWithWordMonsterError, "ChecksActivityMutations.useUpsertActivityState");
  var mutation = match[0];
  return function (studentActivityAttemptId, state) {
    if (state !== undefined) {
      Curry._8(mutation, undefined, undefined, undefined, undefined, undefined, undefined, undefined, {
            state: state,
            studentActivityAttemptId: Caml_option.some(studentActivityAttemptId)
          });
      return ;
    }
    
  };
}

var Raw$1 = {};

var query$1 = Client.gql(["mutation InsertChecksAttempt($id: uuid, $assignationId: uuid, $activityId: uuid, $gameKind: String)  {\ninsertChecksAttempt: insert_literacy_checks_activity_scores_one(object: {assignationId: $assignationId, activityId: $activityId, attempt: {data: {id: $id, gameKind: $gameKind}}})  {\n__typename  \nstudentActivityAttemptId  \n}\n\n}\n"]);

function parse$1(value) {
  var value$1 = value.insertChecksAttempt;
  return {
          insertChecksAttempt: !(value$1 == null) ? ({
                __typename: value$1.__typename,
                studentActivityAttemptId: value$1.studentActivityAttemptId
              }) : undefined
        };
}

function serialize$1(value) {
  var value$1 = value.insertChecksAttempt;
  var insertChecksAttempt;
  if (value$1 !== undefined) {
    var value$2 = value$1.studentActivityAttemptId;
    var value$3 = value$1.__typename;
    insertChecksAttempt = {
      __typename: value$3,
      studentActivityAttemptId: value$2
    };
  } else {
    insertChecksAttempt = null;
  }
  return {
          insertChecksAttempt: insertChecksAttempt
        };
}

function serializeVariables$1(inp) {
  var a = inp.id;
  var a$1 = inp.assignationId;
  var a$2 = inp.activityId;
  var a$3 = inp.gameKind;
  return {
          id: a !== undefined ? Caml_option.valFromOption(a) : undefined,
          assignationId: a$1 !== undefined ? Caml_option.valFromOption(a$1) : undefined,
          activityId: a$2 !== undefined ? Caml_option.valFromOption(a$2) : undefined,
          gameKind: a$3 !== undefined ? a$3 : undefined
        };
}

function makeVariables$1(id, assignationId, activityId, gameKind, param) {
  return {
          id: id,
          assignationId: assignationId,
          activityId: activityId,
          gameKind: gameKind
        };
}

function makeDefaultVariables$1(param) {
  return {
          id: undefined,
          assignationId: undefined,
          activityId: undefined,
          gameKind: undefined
        };
}

var InsertAttemptMutation_inner = {
  Raw: Raw$1,
  query: query$1,
  parse: parse$1,
  serialize: serialize$1,
  serializeVariables: serializeVariables$1,
  makeVariables: makeVariables$1,
  makeDefaultVariables: makeDefaultVariables$1
};

var include$1 = ApolloClient__React_Hooks_UseMutation.Extend({
      query: query$1,
      Raw: Raw$1,
      parse: parse$1,
      serialize: serialize$1,
      serializeVariables: serializeVariables$1
    });

var use$1 = include$1.use;

var InsertAttemptMutation_useWithVariables = include$1.useWithVariables;

var InsertAttemptMutation = {
  InsertAttemptMutation_inner: InsertAttemptMutation_inner,
  Raw: Raw$1,
  query: query$1,
  parse: parse$1,
  serialize: serialize$1,
  serializeVariables: serializeVariables$1,
  makeVariables: makeVariables$1,
  makeDefaultVariables: makeDefaultVariables$1,
  use: use$1,
  useWithVariables: InsertAttemptMutation_useWithVariables
};

var InsertAttempt = MutationHook$LiteracyplanetClientFlags.Make({
      Raw: Raw$1,
      use: use$1
    });

function useInsertAttempt(assignationId, gameId, activityId) {
  var match = React.useState(function () {
        
      });
  var setAttemptId = match[1];
  var match$1 = Curry._1(InsertAttempt.useWithWordMonsterError, "ChecksActivityMutations.useInsertAttempt");
  var data = match$1[3];
  var mutation = match$1[0];
  var id = React.useMemo(function () {
        return Uuid.v4();
      });
  React.useEffect((function () {
          Belt_Option.map(data, (function (d) {
                  return Belt_Option.map(Belt_Option.map(d.insertChecksAttempt, (function (a) {
                                    return a.studentActivityAttemptId;
                                  })), (function (id) {
                                return Curry._1(setAttemptId, (function (param) {
                                              return Json_decode.string(id);
                                            }));
                              }));
                }));
          
        }), [data]);
  var insert = function (param) {
    Curry._8(mutation, undefined, undefined, undefined, undefined, undefined, undefined, undefined, {
          id: Caml_option.some(id),
          assignationId: Caml_option.some(assignationId),
          activityId: Caml_option.some(activityId),
          gameKind: gameId
        });
    
  };
  return [
          insert,
          match[0]
        ];
}

var Raw$2 = {};

var query$2 = Client.gql(["mutation InsertStudentQuestionResponses($responses: [student_question_responses_insert_input!]!)  {\ninsert_student_question_responses(objects: $responses)  {\n__typename  \n}\n\n}\n"]);

function parse$2(value) {
  var value$1 = value.insert_student_question_responses;
  return {
          insert_student_question_responses: !(value$1 == null) ? ({
                __typename: value$1.__typename
              }) : undefined
        };
}

function serialize$2(value) {
  var value$1 = value.insert_student_question_responses;
  var insert_student_question_responses;
  if (value$1 !== undefined) {
    var value$2 = value$1.__typename;
    insert_student_question_responses = {
      __typename: value$2
    };
  } else {
    insert_student_question_responses = null;
  }
  return {
          insert_student_question_responses: insert_student_question_responses
        };
}

function serializeInputObjectstudent_activity_attempts_bool_exp(inp) {
  var a = inp._and;
  var a$1 = inp._not;
  var a$2 = inp._or;
  var a$3 = inp.complete;
  var a$4 = inp.completedAt;
  var a$5 = inp.createdAt;
  var a$6 = inp.gameKind;
  var a$7 = inp.id;
  var a$8 = inp.myWordsAttempt;
  var a$9 = inp.responses;
  var a$10 = inp.updatedAt;
  var a$11 = inp.userId;
  return {
          _and: a !== undefined ? a.map(serializeInputObjectstudent_activity_attempts_bool_exp) : undefined,
          _not: a$1 !== undefined ? serializeInputObjectstudent_activity_attempts_bool_exp(a$1) : undefined,
          _or: a$2 !== undefined ? a$2.map(serializeInputObjectstudent_activity_attempts_bool_exp) : undefined,
          complete: a$3 !== undefined ? serializeInputObjectBoolean_comparison_exp(a$3) : undefined,
          completedAt: a$4 !== undefined ? serializeInputObjecttimestamptz_comparison_exp(a$4) : undefined,
          createdAt: a$5 !== undefined ? serializeInputObjecttimestamptz_comparison_exp(a$5) : undefined,
          gameKind: a$6 !== undefined ? serializeInputObjectString_comparison_exp(a$6) : undefined,
          id: a$7 !== undefined ? serializeInputObjectuuid_comparison_exp(a$7) : undefined,
          myWordsAttempt: a$8 !== undefined ? serializeInputObjectmy_words_attempts_bool_exp(a$8) : undefined,
          responses: a$9 !== undefined ? serializeInputObjectstudent_question_responses_bool_exp(a$9) : undefined,
          updatedAt: a$10 !== undefined ? serializeInputObjecttimestamp_comparison_exp(a$10) : undefined,
          userId: a$11 !== undefined ? serializeInputObjectuuid_comparison_exp(a$11) : undefined
        };
}

function serializeInputObjectstudent_question_responses_bool_exp(inp) {
  var a = inp._and;
  var a$1 = inp._not;
  var a$2 = inp._or;
  var a$3 = inp.answer;
  var a$4 = inp.attempt;
  var a$5 = inp.attemptedAt;
  var a$6 = inp.id;
  var a$7 = inp.points;
  var a$8 = inp.questionIndex;
  var a$9 = inp.state;
  var a$10 = inp.studentActivityAttemptId;
  return {
          _and: a !== undefined ? a.map(serializeInputObjectstudent_question_responses_bool_exp) : undefined,
          _not: a$1 !== undefined ? serializeInputObjectstudent_question_responses_bool_exp(a$1) : undefined,
          _or: a$2 !== undefined ? a$2.map(serializeInputObjectstudent_question_responses_bool_exp) : undefined,
          answer: a$3 !== undefined ? serializeInputObjectString_comparison_exp(a$3) : undefined,
          attempt: a$4 !== undefined ? serializeInputObjectstudent_activity_attempts_bool_exp(a$4) : undefined,
          attemptedAt: a$5 !== undefined ? serializeInputObjecttimestamptz_comparison_exp(a$5) : undefined,
          id: a$6 !== undefined ? serializeInputObjectuuid_comparison_exp(a$6) : undefined,
          points: a$7 !== undefined ? serializeInputObjectInt_comparison_exp(a$7) : undefined,
          questionIndex: a$8 !== undefined ? serializeInputObjectInt_comparison_exp(a$8) : undefined,
          state: a$9 !== undefined ? serializeInputObjectString_comparison_exp(a$9) : undefined,
          studentActivityAttemptId: a$10 !== undefined ? serializeInputObjectuuid_comparison_exp(a$10) : undefined
        };
}

function serializeInputObjectString_comparison_exp(inp) {
  var a = inp._eq;
  var a$1 = inp._gt;
  var a$2 = inp._gte;
  var a$3 = inp._ilike;
  var a$4 = inp._in;
  var a$5 = inp._iregex;
  var a$6 = inp._is_null;
  var a$7 = inp._like;
  var a$8 = inp._lt;
  var a$9 = inp._lte;
  var a$10 = inp._neq;
  var a$11 = inp._nilike;
  var a$12 = inp._nin;
  var a$13 = inp._niregex;
  var a$14 = inp._nlike;
  var a$15 = inp._nregex;
  var a$16 = inp._nsimilar;
  var a$17 = inp._regex;
  var a$18 = inp._similar;
  return {
          _eq: a !== undefined ? a : undefined,
          _gt: a$1 !== undefined ? a$1 : undefined,
          _gte: a$2 !== undefined ? a$2 : undefined,
          _ilike: a$3 !== undefined ? a$3 : undefined,
          _in: a$4 !== undefined ? a$4.map(function (b) {
                  return b;
                }) : undefined,
          _iregex: a$5 !== undefined ? a$5 : undefined,
          _is_null: a$6 !== undefined ? a$6 : undefined,
          _like: a$7 !== undefined ? a$7 : undefined,
          _lt: a$8 !== undefined ? a$8 : undefined,
          _lte: a$9 !== undefined ? a$9 : undefined,
          _neq: a$10 !== undefined ? a$10 : undefined,
          _nilike: a$11 !== undefined ? a$11 : undefined,
          _nin: a$12 !== undefined ? a$12.map(function (b) {
                  return b;
                }) : undefined,
          _niregex: a$13 !== undefined ? a$13 : undefined,
          _nlike: a$14 !== undefined ? a$14 : undefined,
          _nregex: a$15 !== undefined ? a$15 : undefined,
          _nsimilar: a$16 !== undefined ? a$16 : undefined,
          _regex: a$17 !== undefined ? a$17 : undefined,
          _similar: a$18 !== undefined ? a$18 : undefined
        };
}

function serializeInputObjecttimestamp_comparison_exp(inp) {
  var a = inp._eq;
  var a$1 = inp._gt;
  var a$2 = inp._gte;
  var a$3 = inp._in;
  var a$4 = inp._is_null;
  var a$5 = inp._lt;
  var a$6 = inp._lte;
  var a$7 = inp._neq;
  var a$8 = inp._nin;
  return {
          _eq: a !== undefined ? Caml_option.valFromOption(a) : undefined,
          _gt: a$1 !== undefined ? Caml_option.valFromOption(a$1) : undefined,
          _gte: a$2 !== undefined ? Caml_option.valFromOption(a$2) : undefined,
          _in: a$3 !== undefined ? a$3.map(function (b) {
                  return b;
                }) : undefined,
          _is_null: a$4 !== undefined ? a$4 : undefined,
          _lt: a$5 !== undefined ? Caml_option.valFromOption(a$5) : undefined,
          _lte: a$6 !== undefined ? Caml_option.valFromOption(a$6) : undefined,
          _neq: a$7 !== undefined ? Caml_option.valFromOption(a$7) : undefined,
          _nin: a$8 !== undefined ? a$8.map(function (b) {
                  return b;
                }) : undefined
        };
}

function serializeInputObjectmy_words_attempts_bool_exp(inp) {
  var a = inp._and;
  var a$1 = inp._not;
  var a$2 = inp._or;
  var a$3 = inp.attempt;
  var a$4 = inp.customWordListId;
  var a$5 = inp.list;
  var a$6 = inp.studentActivityAttemptId;
  return {
          _and: a !== undefined ? a.map(serializeInputObjectmy_words_attempts_bool_exp) : undefined,
          _not: a$1 !== undefined ? serializeInputObjectmy_words_attempts_bool_exp(a$1) : undefined,
          _or: a$2 !== undefined ? a$2.map(serializeInputObjectmy_words_attempts_bool_exp) : undefined,
          attempt: a$3 !== undefined ? serializeInputObjectstudent_activity_attempts_bool_exp(a$3) : undefined,
          customWordListId: a$4 !== undefined ? serializeInputObjectuuid_comparison_exp(a$4) : undefined,
          list: a$5 !== undefined ? serializeInputObjectcustom_word_lists_bool_exp(a$5) : undefined,
          studentActivityAttemptId: a$6 !== undefined ? serializeInputObjectuuid_comparison_exp(a$6) : undefined
        };
}

function serializeInputObjecttimestamptz_comparison_exp(inp) {
  var a = inp._eq;
  var a$1 = inp._gt;
  var a$2 = inp._gte;
  var a$3 = inp._in;
  var a$4 = inp._is_null;
  var a$5 = inp._lt;
  var a$6 = inp._lte;
  var a$7 = inp._neq;
  var a$8 = inp._nin;
  return {
          _eq: a !== undefined ? Caml_option.valFromOption(a) : undefined,
          _gt: a$1 !== undefined ? Caml_option.valFromOption(a$1) : undefined,
          _gte: a$2 !== undefined ? Caml_option.valFromOption(a$2) : undefined,
          _in: a$3 !== undefined ? a$3.map(function (b) {
                  return b;
                }) : undefined,
          _is_null: a$4 !== undefined ? a$4 : undefined,
          _lt: a$5 !== undefined ? Caml_option.valFromOption(a$5) : undefined,
          _lte: a$6 !== undefined ? Caml_option.valFromOption(a$6) : undefined,
          _neq: a$7 !== undefined ? Caml_option.valFromOption(a$7) : undefined,
          _nin: a$8 !== undefined ? a$8.map(function (b) {
                  return b;
                }) : undefined
        };
}

function serializeInputObjectuuid_comparison_exp(inp) {
  var a = inp._eq;
  var a$1 = inp._gt;
  var a$2 = inp._gte;
  var a$3 = inp._in;
  var a$4 = inp._is_null;
  var a$5 = inp._lt;
  var a$6 = inp._lte;
  var a$7 = inp._neq;
  var a$8 = inp._nin;
  return {
          _eq: a !== undefined ? Caml_option.valFromOption(a) : undefined,
          _gt: a$1 !== undefined ? Caml_option.valFromOption(a$1) : undefined,
          _gte: a$2 !== undefined ? Caml_option.valFromOption(a$2) : undefined,
          _in: a$3 !== undefined ? a$3.map(function (b) {
                  return b;
                }) : undefined,
          _is_null: a$4 !== undefined ? a$4 : undefined,
          _lt: a$5 !== undefined ? Caml_option.valFromOption(a$5) : undefined,
          _lte: a$6 !== undefined ? Caml_option.valFromOption(a$6) : undefined,
          _neq: a$7 !== undefined ? Caml_option.valFromOption(a$7) : undefined,
          _nin: a$8 !== undefined ? a$8.map(function (b) {
                  return b;
                }) : undefined
        };
}

function serializeInputObjectBoolean_comparison_exp(inp) {
  var a = inp._eq;
  var a$1 = inp._gt;
  var a$2 = inp._gte;
  var a$3 = inp._in;
  var a$4 = inp._is_null;
  var a$5 = inp._lt;
  var a$6 = inp._lte;
  var a$7 = inp._neq;
  var a$8 = inp._nin;
  return {
          _eq: a !== undefined ? a : undefined,
          _gt: a$1 !== undefined ? a$1 : undefined,
          _gte: a$2 !== undefined ? a$2 : undefined,
          _in: a$3 !== undefined ? a$3.map(function (b) {
                  return b;
                }) : undefined,
          _is_null: a$4 !== undefined ? a$4 : undefined,
          _lt: a$5 !== undefined ? a$5 : undefined,
          _lte: a$6 !== undefined ? a$6 : undefined,
          _neq: a$7 !== undefined ? a$7 : undefined,
          _nin: a$8 !== undefined ? a$8.map(function (b) {
                  return b;
                }) : undefined
        };
}

function serializeInputObjectmission_templates_obj_rel_insert_input(inp) {
  var a = inp.on_conflict;
  return {
          data: serializeInputObjectmission_templates_insert_input(inp.data),
          on_conflict: a !== undefined ? serializeInputObjectmission_templates_on_conflict(a) : undefined
        };
}

function serializeInputObjectcustom_word_lists_obj_rel_insert_input(inp) {
  var a = inp.on_conflict;
  return {
          data: serializeInputObjectcustom_word_lists_insert_input(inp.data),
          on_conflict: a !== undefined ? serializeInputObjectcustom_word_lists_on_conflict(a) : undefined
        };
}

function serializeInputObjectInt_comparison_exp(inp) {
  var a = inp._eq;
  var a$1 = inp._gt;
  var a$2 = inp._gte;
  var a$3 = inp._in;
  var a$4 = inp._is_null;
  var a$5 = inp._lt;
  var a$6 = inp._lte;
  var a$7 = inp._neq;
  var a$8 = inp._nin;
  return {
          _eq: a !== undefined ? a : undefined,
          _gt: a$1 !== undefined ? a$1 : undefined,
          _gte: a$2 !== undefined ? a$2 : undefined,
          _in: a$3 !== undefined ? a$3.map(function (b) {
                  return b;
                }) : undefined,
          _is_null: a$4 !== undefined ? a$4 : undefined,
          _lt: a$5 !== undefined ? a$5 : undefined,
          _lte: a$6 !== undefined ? a$6 : undefined,
          _neq: a$7 !== undefined ? a$7 : undefined,
          _nin: a$8 !== undefined ? a$8.map(function (b) {
                  return b;
                }) : undefined
        };
}

function serializeInputObjectmission_strands_bool_exp(inp) {
  var a = inp._and;
  var a$1 = inp._not;
  var a$2 = inp._or;
  var a$3 = inp.id;
  var a$4 = inp.name;
  return {
          _and: a !== undefined ? a.map(serializeInputObjectmission_strands_bool_exp) : undefined,
          _not: a$1 !== undefined ? serializeInputObjectmission_strands_bool_exp(a$1) : undefined,
          _or: a$2 !== undefined ? a$2.map(serializeInputObjectmission_strands_bool_exp) : undefined,
          id: a$3 !== undefined ? serializeInputObjectInt_comparison_exp(a$3) : undefined,
          name: a$4 !== undefined ? serializeInputObjectString_comparison_exp(a$4) : undefined
        };
}

function serializeInputObjectactivity_templates_bool_exp(inp) {
  var a = inp._and;
  var a$1 = inp._not;
  var a$2 = inp._or;
  var a$3 = inp.created_at;
  var a$4 = inp.id;
  var a$5 = inp.kind;
  var a$6 = inp.missionTemplateId;
  var a$7 = inp.mission_template;
  var a$8 = inp.mode;
  var a$9 = inp.name;
  var a$10 = inp.order;
  var a$11 = inp.updated_at;
  return {
          _and: a !== undefined ? a.map(serializeInputObjectactivity_templates_bool_exp) : undefined,
          _not: a$1 !== undefined ? serializeInputObjectactivity_templates_bool_exp(a$1) : undefined,
          _or: a$2 !== undefined ? a$2.map(serializeInputObjectactivity_templates_bool_exp) : undefined,
          created_at: a$3 !== undefined ? serializeInputObjecttimestamptz_comparison_exp(a$3) : undefined,
          id: a$4 !== undefined ? serializeInputObjectuuid_comparison_exp(a$4) : undefined,
          kind: a$5 !== undefined ? serializeInputObjectString_comparison_exp(a$5) : undefined,
          missionTemplateId: a$6 !== undefined ? serializeInputObjectuuid_comparison_exp(a$6) : undefined,
          mission_template: a$7 !== undefined ? serializeInputObjectmission_templates_bool_exp(a$7) : undefined,
          mode: a$8 !== undefined ? serializeInputObjectString_comparison_exp(a$8) : undefined,
          name: a$9 !== undefined ? serializeInputObjectString_comparison_exp(a$9) : undefined,
          order: a$10 !== undefined ? serializeInputObjectInt_comparison_exp(a$10) : undefined,
          updated_at: a$11 !== undefined ? serializeInputObjecttimestamptz_comparison_exp(a$11) : undefined
        };
}

function serializeInputObjectcustom_word_list_assignments_bool_exp(inp) {
  var a = inp._and;
  var a$1 = inp._not;
  var a$2 = inp._or;
  var a$3 = inp.createdAt;
  var a$4 = inp.customAssignmentRef;
  var a$5 = inp.customWordList;
  var a$6 = inp.customWordListId;
  var a$7 = inp.missionTemplate;
  var a$8 = inp.missionTemplateId;
  var a$9 = inp.updatedAt;
  return {
          _and: a !== undefined ? a.map(serializeInputObjectcustom_word_list_assignments_bool_exp) : undefined,
          _not: a$1 !== undefined ? serializeInputObjectcustom_word_list_assignments_bool_exp(a$1) : undefined,
          _or: a$2 !== undefined ? a$2.map(serializeInputObjectcustom_word_list_assignments_bool_exp) : undefined,
          createdAt: a$3 !== undefined ? serializeInputObjecttimestamptz_comparison_exp(a$3) : undefined,
          customAssignmentRef: a$4 !== undefined ? serializeInputObjectuuid_comparison_exp(a$4) : undefined,
          customWordList: a$5 !== undefined ? serializeInputObjectcustom_word_lists_bool_exp(a$5) : undefined,
          customWordListId: a$6 !== undefined ? serializeInputObjectuuid_comparison_exp(a$6) : undefined,
          missionTemplate: a$7 !== undefined ? serializeInputObjectmission_templates_bool_exp(a$7) : undefined,
          missionTemplateId: a$8 !== undefined ? serializeInputObjectuuid_comparison_exp(a$8) : undefined,
          updatedAt: a$9 !== undefined ? serializeInputObjecttimestamptz_comparison_exp(a$9) : undefined
        };
}

function serializeInputObjectcustom_word_lists_bool_exp(inp) {
  var a = inp._and;
  var a$1 = inp._not;
  var a$2 = inp._or;
  var a$3 = inp.assigned;
  var a$4 = inp.assignments;
  var a$5 = inp.bestScoresByGame;
  var a$6 = inp.created_at;
  var a$7 = inp.id;
  var a$8 = inp.name;
  var a$9 = inp.orgId;
  var a$10 = inp.owner;
  var a$11 = inp.status;
  var a$12 = inp.updated_at;
  var a$13 = inp.userId;
  var a$14 = inp.words;
  return {
          _and: a !== undefined ? a.map(serializeInputObjectcustom_word_lists_bool_exp) : undefined,
          _not: a$1 !== undefined ? serializeInputObjectcustom_word_lists_bool_exp(a$1) : undefined,
          _or: a$2 !== undefined ? a$2.map(serializeInputObjectcustom_word_lists_bool_exp) : undefined,
          assigned: a$3 !== undefined ? serializeInputObjectBoolean_comparison_exp(a$3) : undefined,
          assignments: a$4 !== undefined ? serializeInputObjectcustom_word_list_assignments_bool_exp(a$4) : undefined,
          bestScoresByGame: a$5 !== undefined ? serializeInputObjectmy_words_best_scores_by_game_bool_exp(a$5) : undefined,
          created_at: a$6 !== undefined ? serializeInputObjecttimestamptz_comparison_exp(a$6) : undefined,
          id: a$7 !== undefined ? serializeInputObjectuuid_comparison_exp(a$7) : undefined,
          name: a$8 !== undefined ? serializeInputObjectString_comparison_exp(a$8) : undefined,
          orgId: a$9 !== undefined ? serializeInputObjectInt_comparison_exp(a$9) : undefined,
          owner: a$10 !== undefined ? serializeInputObjectString_comparison_exp(a$10) : undefined,
          status: a$11 !== undefined ? serializeInputObjectcustom_word_lists_status_enum_comparison_exp(a$11) : undefined,
          updated_at: a$12 !== undefined ? serializeInputObjecttimestamptz_comparison_exp(a$12) : undefined,
          userId: a$13 !== undefined ? serializeInputObjectuuid_comparison_exp(a$13) : undefined,
          words: a$14 !== undefined ? serializeInputObjectlist_words_bool_exp(a$14) : undefined
        };
}

function serializeInputObjectlist_words_bool_exp(inp) {
  var a = inp._and;
  var a$1 = inp._not;
  var a$2 = inp._or;
  var a$3 = inp.createdAt;
  var a$4 = inp.customWordListId;
  var a$5 = inp.custom_word_list;
  var a$6 = inp.name;
  var a$7 = inp.updatedAt;
  var a$8 = inp.userId;
  var a$9 = inp.wordId;
  return {
          _and: a !== undefined ? a.map(serializeInputObjectlist_words_bool_exp) : undefined,
          _not: a$1 !== undefined ? serializeInputObjectlist_words_bool_exp(a$1) : undefined,
          _or: a$2 !== undefined ? a$2.map(serializeInputObjectlist_words_bool_exp) : undefined,
          createdAt: a$3 !== undefined ? serializeInputObjecttimestamptz_comparison_exp(a$3) : undefined,
          customWordListId: a$4 !== undefined ? serializeInputObjectuuid_comparison_exp(a$4) : undefined,
          custom_word_list: a$5 !== undefined ? serializeInputObjectcustom_word_lists_bool_exp(a$5) : undefined,
          name: a$6 !== undefined ? serializeInputObjectString_comparison_exp(a$6) : undefined,
          updatedAt: a$7 !== undefined ? serializeInputObjecttimestamptz_comparison_exp(a$7) : undefined,
          userId: a$8 !== undefined ? serializeInputObjectuuid_comparison_exp(a$8) : undefined,
          wordId: a$9 !== undefined ? serializeInputObjectuuid_comparison_exp(a$9) : undefined
        };
}

function serializeInputObjectcustom_word_lists_status_enum_comparison_exp(inp) {
  var a = inp._eq;
  var a$1 = inp._in;
  var a$2 = inp._is_null;
  var a$3 = inp._neq;
  var a$4 = inp._nin;
  return {
          _eq: a !== undefined ? (
              a === "Shared" ? "Shared" : (
                  a === "Private" ? "Private" : "Archived"
                )
            ) : undefined,
          _in: a$1 !== undefined ? a$1.map(function (b) {
                  if (b === "Shared") {
                    return "Shared";
                  } else if (b === "Private") {
                    return "Private";
                  } else {
                    return "Archived";
                  }
                }) : undefined,
          _is_null: a$2 !== undefined ? a$2 : undefined,
          _neq: a$3 !== undefined ? (
              a$3 === "Shared" ? "Shared" : (
                  a$3 === "Private" ? "Private" : "Archived"
                )
            ) : undefined,
          _nin: a$4 !== undefined ? a$4.map(function (b) {
                  if (b === "Shared") {
                    return "Shared";
                  } else if (b === "Private") {
                    return "Private";
                  } else {
                    return "Archived";
                  }
                }) : undefined
        };
}

function serializeInputObjectmy_words_best_scores_by_game_bool_exp(inp) {
  var a = inp._and;
  var a$1 = inp._not;
  var a$2 = inp._or;
  var a$3 = inp.attempts;
  var a$4 = inp.correct;
  var a$5 = inp.count;
  var a$6 = inp.customWordListId;
  var a$7 = inp.gameKind;
  var a$8 = inp.userId;
  return {
          _and: a !== undefined ? a.map(serializeInputObjectmy_words_best_scores_by_game_bool_exp) : undefined,
          _not: a$1 !== undefined ? serializeInputObjectmy_words_best_scores_by_game_bool_exp(a$1) : undefined,
          _or: a$2 !== undefined ? a$2.map(serializeInputObjectmy_words_best_scores_by_game_bool_exp) : undefined,
          attempts: a$3 !== undefined ? serializeInputObjectbigint_comparison_exp(a$3) : undefined,
          correct: a$4 !== undefined ? serializeInputObjectbigint_comparison_exp(a$4) : undefined,
          count: a$5 !== undefined ? serializeInputObjectbigint_comparison_exp(a$5) : undefined,
          customWordListId: a$6 !== undefined ? serializeInputObjectuuid_comparison_exp(a$6) : undefined,
          gameKind: a$7 !== undefined ? serializeInputObjectString_comparison_exp(a$7) : undefined,
          userId: a$8 !== undefined ? serializeInputObjectuuid_comparison_exp(a$8) : undefined
        };
}

function serializeInputObjectstudent_question_responses_insert_input(inp) {
  var a = inp.answer;
  var a$1 = inp.attempt;
  var a$2 = inp.attemptedAt;
  var a$3 = inp.id;
  var a$4 = inp.points;
  var a$5 = inp.questionIndex;
  var a$6 = inp.state;
  var a$7 = inp.studentActivityAttemptId;
  return {
          answer: a !== undefined ? a : undefined,
          attempt: a$1 !== undefined ? serializeInputObjectstudent_activity_attempts_obj_rel_insert_input(a$1) : undefined,
          attemptedAt: a$2 !== undefined ? Caml_option.valFromOption(a$2) : undefined,
          id: a$3 !== undefined ? Caml_option.valFromOption(a$3) : undefined,
          points: a$4 !== undefined ? a$4 : undefined,
          questionIndex: a$5 !== undefined ? a$5 : undefined,
          state: a$6 !== undefined ? a$6 : undefined,
          studentActivityAttemptId: a$7 !== undefined ? Caml_option.valFromOption(a$7) : undefined
        };
}

function serializeInputObjectstudent_question_responses_on_conflict(inp) {
  var a = inp.constraint;
  var a$1 = inp.update_columns;
  var a$2 = inp.where;
  return {
          constraint: a === "student_question_responses_pkey" ? "student_question_responses_pkey" : "student_question_responses_studentActivityAttemptId_questio_key",
          update_columns: a$1.map(function (b) {
                if (b === "answer") {
                  return "answer";
                } else if (b === "questionIndex") {
                  return "questionIndex";
                } else if (b === "points") {
                  return "points";
                } else if (b === "id") {
                  return "id";
                } else if (b === "state") {
                  return "state";
                } else if (b === "attemptedAt") {
                  return "attemptedAt";
                } else {
                  return "studentActivityAttemptId";
                }
              }),
          where: a$2 !== undefined ? serializeInputObjectstudent_question_responses_bool_exp(a$2) : undefined
        };
}

function serializeInputObjectactivity_templates_arr_rel_insert_input(inp) {
  var a = inp.data;
  var a$1 = inp.on_conflict;
  return {
          data: a.map(serializeInputObjectactivity_templates_insert_input),
          on_conflict: a$1 !== undefined ? serializeInputObjectactivity_templates_on_conflict(a$1) : undefined
        };
}

function serializeInputObjectmission_strands_obj_rel_insert_input(inp) {
  var a = inp.on_conflict;
  return {
          data: serializeInputObjectmission_strands_insert_input(inp.data),
          on_conflict: a !== undefined ? serializeInputObjectmission_strands_on_conflict(a) : undefined
        };
}

function serializeInputObjectcustom_word_list_assignments_arr_rel_insert_input(inp) {
  var a = inp.data;
  var a$1 = inp.on_conflict;
  return {
          data: a.map(serializeInputObjectcustom_word_list_assignments_insert_input),
          on_conflict: a$1 !== undefined ? serializeInputObjectcustom_word_list_assignments_on_conflict(a$1) : undefined
        };
}

function serializeInputObjectbigint_comparison_exp(inp) {
  var a = inp._eq;
  var a$1 = inp._gt;
  var a$2 = inp._gte;
  var a$3 = inp._in;
  var a$4 = inp._is_null;
  var a$5 = inp._lt;
  var a$6 = inp._lte;
  var a$7 = inp._neq;
  var a$8 = inp._nin;
  return {
          _eq: a !== undefined ? Caml_option.valFromOption(a) : undefined,
          _gt: a$1 !== undefined ? Caml_option.valFromOption(a$1) : undefined,
          _gte: a$2 !== undefined ? Caml_option.valFromOption(a$2) : undefined,
          _in: a$3 !== undefined ? a$3.map(function (b) {
                  return b;
                }) : undefined,
          _is_null: a$4 !== undefined ? a$4 : undefined,
          _lt: a$5 !== undefined ? Caml_option.valFromOption(a$5) : undefined,
          _lte: a$6 !== undefined ? Caml_option.valFromOption(a$6) : undefined,
          _neq: a$7 !== undefined ? Caml_option.valFromOption(a$7) : undefined,
          _nin: a$8 !== undefined ? a$8.map(function (b) {
                  return b;
                }) : undefined
        };
}

function serializeInputObjectmy_words_attempts_insert_input(inp) {
  var a = inp.attempt;
  var a$1 = inp.customWordListId;
  var a$2 = inp.list;
  var a$3 = inp.studentActivityAttemptId;
  return {
          attempt: a !== undefined ? serializeInputObjectstudent_activity_attempts_obj_rel_insert_input(a) : undefined,
          customWordListId: a$1 !== undefined ? Caml_option.valFromOption(a$1) : undefined,
          list: a$2 !== undefined ? serializeInputObjectcustom_word_lists_obj_rel_insert_input(a$2) : undefined,
          studentActivityAttemptId: a$3 !== undefined ? Caml_option.valFromOption(a$3) : undefined
        };
}

function serializeInputObjectmy_words_attempts_on_conflict(inp) {
  var a = inp.update_columns;
  var a$1 = inp.where;
  return {
          constraint: "my_words_attempts_pkey",
          update_columns: a.map(function (b) {
                if (b === "customWordListId") {
                  return "customWordListId";
                } else {
                  return "studentActivityAttemptId";
                }
              }),
          where: a$1 !== undefined ? serializeInputObjectmy_words_attempts_bool_exp(a$1) : undefined
        };
}

function serializeInputObjectmy_words_best_scores_by_game_insert_input(inp) {
  var a = inp.attempts;
  var a$1 = inp.correct;
  var a$2 = inp.count;
  var a$3 = inp.customWordListId;
  var a$4 = inp.gameKind;
  var a$5 = inp.userId;
  return {
          attempts: a !== undefined ? Caml_option.valFromOption(a) : undefined,
          correct: a$1 !== undefined ? Caml_option.valFromOption(a$1) : undefined,
          count: a$2 !== undefined ? Caml_option.valFromOption(a$2) : undefined,
          customWordListId: a$3 !== undefined ? Caml_option.valFromOption(a$3) : undefined,
          gameKind: a$4 !== undefined ? a$4 : undefined,
          userId: a$5 !== undefined ? Caml_option.valFromOption(a$5) : undefined
        };
}

function serializeInputObjectstudent_question_responses_arr_rel_insert_input(inp) {
  var a = inp.data;
  var a$1 = inp.on_conflict;
  return {
          data: a.map(serializeInputObjectstudent_question_responses_insert_input),
          on_conflict: a$1 !== undefined ? serializeInputObjectstudent_question_responses_on_conflict(a$1) : undefined
        };
}

function serializeInputObjectmy_words_attempts_obj_rel_insert_input(inp) {
  var a = inp.on_conflict;
  return {
          data: serializeInputObjectmy_words_attempts_insert_input(inp.data),
          on_conflict: a !== undefined ? serializeInputObjectmy_words_attempts_on_conflict(a) : undefined
        };
}

function serializeInputObjectmission_templates_bool_exp(inp) {
  var a = inp._and;
  var a$1 = inp._not;
  var a$2 = inp._or;
  var a$3 = inp.activities;
  var a$4 = inp.assignments;
  var a$5 = inp.created_at;
  var a$6 = inp.id;
  var a$7 = inp.name;
  var a$8 = inp.order;
  var a$9 = inp.strand;
  var a$10 = inp.strandId;
  var a$11 = inp.updated_at;
  return {
          _and: a !== undefined ? a.map(serializeInputObjectmission_templates_bool_exp) : undefined,
          _not: a$1 !== undefined ? serializeInputObjectmission_templates_bool_exp(a$1) : undefined,
          _or: a$2 !== undefined ? a$2.map(serializeInputObjectmission_templates_bool_exp) : undefined,
          activities: a$3 !== undefined ? serializeInputObjectactivity_templates_bool_exp(a$3) : undefined,
          assignments: a$4 !== undefined ? serializeInputObjectcustom_word_list_assignments_bool_exp(a$4) : undefined,
          created_at: a$5 !== undefined ? serializeInputObjecttimestamptz_comparison_exp(a$5) : undefined,
          id: a$6 !== undefined ? serializeInputObjectuuid_comparison_exp(a$6) : undefined,
          name: a$7 !== undefined ? serializeInputObjectString_comparison_exp(a$7) : undefined,
          order: a$8 !== undefined ? serializeInputObjectInt_comparison_exp(a$8) : undefined,
          strand: a$9 !== undefined ? serializeInputObjectmission_strands_bool_exp(a$9) : undefined,
          strandId: a$10 !== undefined ? serializeInputObjectInt_comparison_exp(a$10) : undefined,
          updated_at: a$11 !== undefined ? serializeInputObjecttimestamptz_comparison_exp(a$11) : undefined
        };
}

function serializeInputObjectmission_strands_insert_input(inp) {
  var a = inp.id;
  var a$1 = inp.name;
  return {
          id: a !== undefined ? a : undefined,
          name: a$1 !== undefined ? a$1 : undefined
        };
}

function serializeInputObjectmission_strands_on_conflict(inp) {
  var a = inp.update_columns;
  var a$1 = inp.where;
  return {
          constraint: "mission_strands_pkey",
          update_columns: a.map(function (b) {
                if (b === "id") {
                  return "id";
                } else {
                  return "name";
                }
              }),
          where: a$1 !== undefined ? serializeInputObjectmission_strands_bool_exp(a$1) : undefined
        };
}

function serializeInputObjectcustom_word_list_assignments_insert_input(inp) {
  var a = inp.createdAt;
  var a$1 = inp.customAssignmentRef;
  var a$2 = inp.customWordList;
  var a$3 = inp.customWordListId;
  var a$4 = inp.missionTemplate;
  var a$5 = inp.missionTemplateId;
  var a$6 = inp.updatedAt;
  return {
          createdAt: a !== undefined ? Caml_option.valFromOption(a) : undefined,
          customAssignmentRef: a$1 !== undefined ? Caml_option.valFromOption(a$1) : undefined,
          customWordList: a$2 !== undefined ? serializeInputObjectcustom_word_lists_obj_rel_insert_input(a$2) : undefined,
          customWordListId: a$3 !== undefined ? Caml_option.valFromOption(a$3) : undefined,
          missionTemplate: a$4 !== undefined ? serializeInputObjectmission_templates_obj_rel_insert_input(a$4) : undefined,
          missionTemplateId: a$5 !== undefined ? Caml_option.valFromOption(a$5) : undefined,
          updatedAt: a$6 !== undefined ? Caml_option.valFromOption(a$6) : undefined
        };
}

function serializeInputObjectcustom_word_list_assignments_on_conflict(inp) {
  var a = inp.constraint;
  var a$1 = inp.update_columns;
  var a$2 = inp.where;
  return {
          constraint: a === "custom_word_list_assignments_pkey" ? "custom_word_list_assignments_pkey" : "custom_word_list_assignments_missionTemplateId_customWordListId",
          update_columns: a$1.map(function (b) {
                if (b === "updatedAt") {
                  return "updatedAt";
                } else if (b === "missionTemplateId") {
                  return "missionTemplateId";
                } else if (b === "customAssignmentRef") {
                  return "customAssignmentRef";
                } else if (b === "customWordListId") {
                  return "customWordListId";
                } else {
                  return "createdAt";
                }
              }),
          where: a$2 !== undefined ? serializeInputObjectcustom_word_list_assignments_bool_exp(a$2) : undefined
        };
}

function serializeInputObjectstudent_activity_attempts_on_conflict(inp) {
  var a = inp.update_columns;
  var a$1 = inp.where;
  return {
          constraint: "student_activity_attempts_pkey",
          update_columns: a.map(function (b) {
                if (b === "createdAt") {
                  return "createdAt";
                } else if (b === "complete") {
                  return "complete";
                } else if (b === "id") {
                  return "id";
                } else if (b === "updatedAt") {
                  return "updatedAt";
                } else if (b === "completedAt") {
                  return "completedAt";
                } else if (b === "gameKind") {
                  return "gameKind";
                } else {
                  return "userId";
                }
              }),
          where: a$1 !== undefined ? serializeInputObjectstudent_activity_attempts_bool_exp(a$1) : undefined
        };
}

function serializeInputObjectstudent_activity_attempts_insert_input(inp) {
  var a = inp.complete;
  var a$1 = inp.completedAt;
  var a$2 = inp.createdAt;
  var a$3 = inp.gameKind;
  var a$4 = inp.id;
  var a$5 = inp.myWordsAttempt;
  var a$6 = inp.responses;
  var a$7 = inp.updatedAt;
  var a$8 = inp.userId;
  return {
          complete: a !== undefined ? a : undefined,
          completedAt: a$1 !== undefined ? Caml_option.valFromOption(a$1) : undefined,
          createdAt: a$2 !== undefined ? Caml_option.valFromOption(a$2) : undefined,
          gameKind: a$3 !== undefined ? a$3 : undefined,
          id: a$4 !== undefined ? Caml_option.valFromOption(a$4) : undefined,
          myWordsAttempt: a$5 !== undefined ? serializeInputObjectmy_words_attempts_obj_rel_insert_input(a$5) : undefined,
          responses: a$6 !== undefined ? serializeInputObjectstudent_question_responses_arr_rel_insert_input(a$6) : undefined,
          updatedAt: a$7 !== undefined ? Caml_option.valFromOption(a$7) : undefined,
          userId: a$8 !== undefined ? Caml_option.valFromOption(a$8) : undefined
        };
}

function serializeInputObjectmission_templates_insert_input(inp) {
  var a = inp.activities;
  var a$1 = inp.assignments;
  var a$2 = inp.created_at;
  var a$3 = inp.id;
  var a$4 = inp.name;
  var a$5 = inp.order;
  var a$6 = inp.strand;
  var a$7 = inp.strandId;
  var a$8 = inp.updated_at;
  return {
          activities: a !== undefined ? serializeInputObjectactivity_templates_arr_rel_insert_input(a) : undefined,
          assignments: a$1 !== undefined ? serializeInputObjectcustom_word_list_assignments_arr_rel_insert_input(a$1) : undefined,
          created_at: a$2 !== undefined ? Caml_option.valFromOption(a$2) : undefined,
          id: a$3 !== undefined ? Caml_option.valFromOption(a$3) : undefined,
          name: a$4 !== undefined ? a$4 : undefined,
          order: a$5 !== undefined ? a$5 : undefined,
          strand: a$6 !== undefined ? serializeInputObjectmission_strands_obj_rel_insert_input(a$6) : undefined,
          strandId: a$7 !== undefined ? a$7 : undefined,
          updated_at: a$8 !== undefined ? Caml_option.valFromOption(a$8) : undefined
        };
}

function serializeInputObjectmission_templates_on_conflict(inp) {
  var a = inp.update_columns;
  var a$1 = inp.where;
  return {
          constraint: "mission_templates_pkey",
          update_columns: a.map(function (b) {
                if (b === "name") {
                  return "name";
                } else if (b === "created_at") {
                  return "created_at";
                } else if (b === "id") {
                  return "id";
                } else if (b === "updated_at") {
                  return "updated_at";
                } else if (b === "order") {
                  return "order";
                } else {
                  return "strandId";
                }
              }),
          where: a$1 !== undefined ? serializeInputObjectmission_templates_bool_exp(a$1) : undefined
        };
}

function serializeInputObjectlist_words_on_conflict(inp) {
  var a = inp.update_columns;
  var a$1 = inp.where;
  return {
          constraint: "list_words_pkey",
          update_columns: a.map(function (b) {
                if (b === "name") {
                  return "name";
                } else if (b === "wordId") {
                  return "wordId";
                } else if (b === "createdAt") {
                  return "createdAt";
                } else if (b === "updatedAt") {
                  return "updatedAt";
                } else if (b === "customWordListId") {
                  return "customWordListId";
                } else {
                  return "userId";
                }
              }),
          where: a$1 !== undefined ? serializeInputObjectlist_words_bool_exp(a$1) : undefined
        };
}

function serializeInputObjectlist_words_insert_input(inp) {
  var a = inp.createdAt;
  var a$1 = inp.customWordListId;
  var a$2 = inp.custom_word_list;
  var a$3 = inp.name;
  var a$4 = inp.updatedAt;
  var a$5 = inp.userId;
  var a$6 = inp.wordId;
  return {
          createdAt: a !== undefined ? Caml_option.valFromOption(a) : undefined,
          customWordListId: a$1 !== undefined ? Caml_option.valFromOption(a$1) : undefined,
          custom_word_list: a$2 !== undefined ? serializeInputObjectcustom_word_lists_obj_rel_insert_input(a$2) : undefined,
          name: a$3 !== undefined ? a$3 : undefined,
          updatedAt: a$4 !== undefined ? Caml_option.valFromOption(a$4) : undefined,
          userId: a$5 !== undefined ? Caml_option.valFromOption(a$5) : undefined,
          wordId: a$6 !== undefined ? Caml_option.valFromOption(a$6) : undefined
        };
}

function serializeInputObjectactivity_templates_on_conflict(inp) {
  var a = inp.update_columns;
  var a$1 = inp.where;
  return {
          constraint: "activity_templates_pkey",
          update_columns: a.map(function (b) {
                if (b === "mode") {
                  return "mode";
                } else if (b === "name") {
                  return "name";
                } else if (b === "created_at") {
                  return "created_at";
                } else if (b === "id") {
                  return "id";
                } else if (b === "missionTemplateId") {
                  return "missionTemplateId";
                } else if (b === "updated_at") {
                  return "updated_at";
                } else if (b === "order") {
                  return "order";
                } else {
                  return "kind";
                }
              }),
          where: a$1 !== undefined ? serializeInputObjectactivity_templates_bool_exp(a$1) : undefined
        };
}

function serializeInputObjectactivity_templates_insert_input(inp) {
  var a = inp.created_at;
  var a$1 = inp.id;
  var a$2 = inp.kind;
  var a$3 = inp.missionTemplateId;
  var a$4 = inp.mission_template;
  var a$5 = inp.mode;
  var a$6 = inp.name;
  var a$7 = inp.order;
  var a$8 = inp.updated_at;
  return {
          created_at: a !== undefined ? Caml_option.valFromOption(a) : undefined,
          id: a$1 !== undefined ? Caml_option.valFromOption(a$1) : undefined,
          kind: a$2 !== undefined ? a$2 : undefined,
          missionTemplateId: a$3 !== undefined ? Caml_option.valFromOption(a$3) : undefined,
          mission_template: a$4 !== undefined ? serializeInputObjectmission_templates_obj_rel_insert_input(a$4) : undefined,
          mode: a$5 !== undefined ? a$5 : undefined,
          name: a$6 !== undefined ? a$6 : undefined,
          order: a$7 !== undefined ? a$7 : undefined,
          updated_at: a$8 !== undefined ? Caml_option.valFromOption(a$8) : undefined
        };
}

function serializeInputObjectcustom_word_lists_on_conflict(inp) {
  var a = inp.update_columns;
  var a$1 = inp.where;
  return {
          constraint: "custom_word_lists_pkey",
          update_columns: a.map(function (b) {
                if (b === "name") {
                  return "name";
                } else if (b === "created_at") {
                  return "created_at";
                } else if (b === "id") {
                  return "id";
                } else if (b === "status") {
                  return "status";
                } else if (b === "assigned") {
                  return "assigned";
                } else if (b === "updated_at") {
                  return "updated_at";
                } else if (b === "orgId") {
                  return "orgId";
                } else if (b === "owner") {
                  return "owner";
                } else {
                  return "userId";
                }
              }),
          where: a$1 !== undefined ? serializeInputObjectcustom_word_lists_bool_exp(a$1) : undefined
        };
}

function serializeInputObjectcustom_word_lists_insert_input(inp) {
  var a = inp.assigned;
  var a$1 = inp.assignments;
  var a$2 = inp.bestScoresByGame;
  var a$3 = inp.created_at;
  var a$4 = inp.id;
  var a$5 = inp.name;
  var a$6 = inp.orgId;
  var a$7 = inp.owner;
  var a$8 = inp.status;
  var a$9 = inp.updated_at;
  var a$10 = inp.userId;
  var a$11 = inp.words;
  return {
          assigned: a !== undefined ? a : undefined,
          assignments: a$1 !== undefined ? serializeInputObjectcustom_word_list_assignments_arr_rel_insert_input(a$1) : undefined,
          bestScoresByGame: a$2 !== undefined ? serializeInputObjectmy_words_best_scores_by_game_arr_rel_insert_input(a$2) : undefined,
          created_at: a$3 !== undefined ? Caml_option.valFromOption(a$3) : undefined,
          id: a$4 !== undefined ? Caml_option.valFromOption(a$4) : undefined,
          name: a$5 !== undefined ? a$5 : undefined,
          orgId: a$6 !== undefined ? a$6 : undefined,
          owner: a$7 !== undefined ? a$7 : undefined,
          status: a$8 !== undefined ? (
              a$8 === "Shared" ? "Shared" : (
                  a$8 === "Private" ? "Private" : "Archived"
                )
            ) : undefined,
          updated_at: a$9 !== undefined ? Caml_option.valFromOption(a$9) : undefined,
          userId: a$10 !== undefined ? Caml_option.valFromOption(a$10) : undefined,
          words: a$11 !== undefined ? serializeInputObjectlist_words_arr_rel_insert_input(a$11) : undefined
        };
}

function serializeInputObjectstudent_activity_attempts_obj_rel_insert_input(inp) {
  var a = inp.on_conflict;
  return {
          data: serializeInputObjectstudent_activity_attempts_insert_input(inp.data),
          on_conflict: a !== undefined ? serializeInputObjectstudent_activity_attempts_on_conflict(a) : undefined
        };
}

function serializeInputObjectlist_words_arr_rel_insert_input(inp) {
  var a = inp.data;
  var a$1 = inp.on_conflict;
  return {
          data: a.map(serializeInputObjectlist_words_insert_input),
          on_conflict: a$1 !== undefined ? serializeInputObjectlist_words_on_conflict(a$1) : undefined
        };
}

function serializeInputObjectmy_words_best_scores_by_game_arr_rel_insert_input(inp) {
  var a = inp.data;
  return {
          data: a.map(serializeInputObjectmy_words_best_scores_by_game_insert_input)
        };
}

function serializeVariables$2(inp) {
  var a = inp.responses;
  return {
          responses: a.map(serializeInputObjectstudent_question_responses_insert_input)
        };
}

function makeVariables$2(responses, param) {
  return {
          responses: responses
        };
}

function makeInputObjectstudent_question_responses_insert_input(answer, attempt, attemptedAt, id, points, questionIndex, state, studentActivityAttemptId, param) {
  return {
          answer: answer,
          attempt: attempt,
          attemptedAt: attemptedAt,
          id: id,
          points: points,
          questionIndex: questionIndex,
          state: state,
          studentActivityAttemptId: studentActivityAttemptId
        };
}

function makeInputObjectstudent_activity_attempts_obj_rel_insert_input(data, on_conflict, param) {
  return {
          data: data,
          on_conflict: on_conflict
        };
}

function makeInputObjectstudent_activity_attempts_insert_input(complete, completedAt, createdAt, gameKind, id, myWordsAttempt, responses, updatedAt, userId, param) {
  return {
          complete: complete,
          completedAt: completedAt,
          createdAt: createdAt,
          gameKind: gameKind,
          id: id,
          myWordsAttempt: myWordsAttempt,
          responses: responses,
          updatedAt: updatedAt,
          userId: userId
        };
}

function makeInputObjectmy_words_attempts_obj_rel_insert_input(data, on_conflict, param) {
  return {
          data: data,
          on_conflict: on_conflict
        };
}

function makeInputObjectmy_words_attempts_insert_input(attempt, customWordListId, list, studentActivityAttemptId, param) {
  return {
          attempt: attempt,
          customWordListId: customWordListId,
          list: list,
          studentActivityAttemptId: studentActivityAttemptId
        };
}

function makeInputObjectcustom_word_lists_obj_rel_insert_input(data, on_conflict, param) {
  return {
          data: data,
          on_conflict: on_conflict
        };
}

function makeInputObjectcustom_word_lists_insert_input(assigned, assignments, bestScoresByGame, created_at, id, name, orgId, owner, status, updated_at, userId, words, param) {
  return {
          assigned: assigned,
          assignments: assignments,
          bestScoresByGame: bestScoresByGame,
          created_at: created_at,
          id: id,
          name: name,
          orgId: orgId,
          owner: owner,
          status: status,
          updated_at: updated_at,
          userId: userId,
          words: words
        };
}

function makeInputObjectcustom_word_list_assignments_arr_rel_insert_input(data, on_conflict, param) {
  return {
          data: data,
          on_conflict: on_conflict
        };
}

function makeInputObjectcustom_word_list_assignments_insert_input(createdAt, customAssignmentRef, customWordList, customWordListId, missionTemplate, missionTemplateId, updatedAt, param) {
  return {
          createdAt: createdAt,
          customAssignmentRef: customAssignmentRef,
          customWordList: customWordList,
          customWordListId: customWordListId,
          missionTemplate: missionTemplate,
          missionTemplateId: missionTemplateId,
          updatedAt: updatedAt
        };
}

function makeInputObjectmission_templates_obj_rel_insert_input(data, on_conflict, param) {
  return {
          data: data,
          on_conflict: on_conflict
        };
}

function makeInputObjectmission_templates_insert_input(activities, assignments, created_at, id, name, order, strand, strandId, updated_at, param) {
  return {
          activities: activities,
          assignments: assignments,
          created_at: created_at,
          id: id,
          name: name,
          order: order,
          strand: strand,
          strandId: strandId,
          updated_at: updated_at
        };
}

function makeInputObjectactivity_templates_arr_rel_insert_input(data, on_conflict, param) {
  return {
          data: data,
          on_conflict: on_conflict
        };
}

function makeInputObjectactivity_templates_insert_input(created_at, id, kind, missionTemplateId, mission_template, mode, name, order, updated_at, param) {
  return {
          created_at: created_at,
          id: id,
          kind: kind,
          missionTemplateId: missionTemplateId,
          mission_template: mission_template,
          mode: mode,
          name: name,
          order: order,
          updated_at: updated_at
        };
}

function makeInputObjectactivity_templates_on_conflict(constraint_, update_columns, where, param) {
  return {
          constraint: constraint_,
          update_columns: update_columns,
          where: where
        };
}

function makeInputObjectactivity_templates_bool_exp(_and, _not, _or, created_at, id, kind, missionTemplateId, mission_template, mode, name, order, updated_at, param) {
  return {
          _and: _and,
          _not: _not,
          _or: _or,
          created_at: created_at,
          id: id,
          kind: kind,
          missionTemplateId: missionTemplateId,
          mission_template: mission_template,
          mode: mode,
          name: name,
          order: order,
          updated_at: updated_at
        };
}

function makeInputObjecttimestamptz_comparison_exp(_eq, _gt, _gte, _in, _is_null, _lt, _lte, _neq, _nin, param) {
  return {
          _eq: _eq,
          _gt: _gt,
          _gte: _gte,
          _in: _in,
          _is_null: _is_null,
          _lt: _lt,
          _lte: _lte,
          _neq: _neq,
          _nin: _nin
        };
}

function makeInputObjectuuid_comparison_exp(_eq, _gt, _gte, _in, _is_null, _lt, _lte, _neq, _nin, param) {
  return {
          _eq: _eq,
          _gt: _gt,
          _gte: _gte,
          _in: _in,
          _is_null: _is_null,
          _lt: _lt,
          _lte: _lte,
          _neq: _neq,
          _nin: _nin
        };
}

function makeInputObjectString_comparison_exp(_eq, _gt, _gte, _ilike, _in, _iregex, _is_null, _like, _lt, _lte, _neq, _nilike, _nin, _niregex, _nlike, _nregex, _nsimilar, _regex, _similar, param) {
  return {
          _eq: _eq,
          _gt: _gt,
          _gte: _gte,
          _ilike: _ilike,
          _in: _in,
          _iregex: _iregex,
          _is_null: _is_null,
          _like: _like,
          _lt: _lt,
          _lte: _lte,
          _neq: _neq,
          _nilike: _nilike,
          _nin: _nin,
          _niregex: _niregex,
          _nlike: _nlike,
          _nregex: _nregex,
          _nsimilar: _nsimilar,
          _regex: _regex,
          _similar: _similar
        };
}

function makeInputObjectmission_templates_bool_exp(_and, _not, _or, activities, assignments, created_at, id, name, order, strand, strandId, updated_at, param) {
  return {
          _and: _and,
          _not: _not,
          _or: _or,
          activities: activities,
          assignments: assignments,
          created_at: created_at,
          id: id,
          name: name,
          order: order,
          strand: strand,
          strandId: strandId,
          updated_at: updated_at
        };
}

function makeInputObjectcustom_word_list_assignments_bool_exp(_and, _not, _or, createdAt, customAssignmentRef, customWordList, customWordListId, missionTemplate, missionTemplateId, updatedAt, param) {
  return {
          _and: _and,
          _not: _not,
          _or: _or,
          createdAt: createdAt,
          customAssignmentRef: customAssignmentRef,
          customWordList: customWordList,
          customWordListId: customWordListId,
          missionTemplate: missionTemplate,
          missionTemplateId: missionTemplateId,
          updatedAt: updatedAt
        };
}

function makeInputObjectcustom_word_lists_bool_exp(_and, _not, _or, assigned, assignments, bestScoresByGame, created_at, id, name, orgId, owner, status, updated_at, userId, words, param) {
  return {
          _and: _and,
          _not: _not,
          _or: _or,
          assigned: assigned,
          assignments: assignments,
          bestScoresByGame: bestScoresByGame,
          created_at: created_at,
          id: id,
          name: name,
          orgId: orgId,
          owner: owner,
          status: status,
          updated_at: updated_at,
          userId: userId,
          words: words
        };
}

function makeInputObjectBoolean_comparison_exp(_eq, _gt, _gte, _in, _is_null, _lt, _lte, _neq, _nin, param) {
  return {
          _eq: _eq,
          _gt: _gt,
          _gte: _gte,
          _in: _in,
          _is_null: _is_null,
          _lt: _lt,
          _lte: _lte,
          _neq: _neq,
          _nin: _nin
        };
}

function makeInputObjectmy_words_best_scores_by_game_bool_exp(_and, _not, _or, attempts, correct, count, customWordListId, gameKind, userId, param) {
  return {
          _and: _and,
          _not: _not,
          _or: _or,
          attempts: attempts,
          correct: correct,
          count: count,
          customWordListId: customWordListId,
          gameKind: gameKind,
          userId: userId
        };
}

function makeInputObjectbigint_comparison_exp(_eq, _gt, _gte, _in, _is_null, _lt, _lte, _neq, _nin, param) {
  return {
          _eq: _eq,
          _gt: _gt,
          _gte: _gte,
          _in: _in,
          _is_null: _is_null,
          _lt: _lt,
          _lte: _lte,
          _neq: _neq,
          _nin: _nin
        };
}

function makeInputObjectInt_comparison_exp(_eq, _gt, _gte, _in, _is_null, _lt, _lte, _neq, _nin, param) {
  return {
          _eq: _eq,
          _gt: _gt,
          _gte: _gte,
          _in: _in,
          _is_null: _is_null,
          _lt: _lt,
          _lte: _lte,
          _neq: _neq,
          _nin: _nin
        };
}

function makeInputObjectcustom_word_lists_status_enum_comparison_exp(_eq, _in, _is_null, _neq, _nin, param) {
  return {
          _eq: _eq,
          _in: _in,
          _is_null: _is_null,
          _neq: _neq,
          _nin: _nin
        };
}

function makeInputObjectlist_words_bool_exp(_and, _not, _or, createdAt, customWordListId, custom_word_list, name, updatedAt, userId, wordId, param) {
  return {
          _and: _and,
          _not: _not,
          _or: _or,
          createdAt: createdAt,
          customWordListId: customWordListId,
          custom_word_list: custom_word_list,
          name: name,
          updatedAt: updatedAt,
          userId: userId,
          wordId: wordId
        };
}

function makeInputObjectmission_strands_bool_exp(_and, _not, _or, id, name, param) {
  return {
          _and: _and,
          _not: _not,
          _or: _or,
          id: id,
          name: name
        };
}

function makeInputObjectmission_strands_obj_rel_insert_input(data, on_conflict, param) {
  return {
          data: data,
          on_conflict: on_conflict
        };
}

function makeInputObjectmission_strands_insert_input(id, name, param) {
  return {
          id: id,
          name: name
        };
}

function makeInputObjectmission_strands_on_conflict(constraint_, update_columns, where, param) {
  return {
          constraint: constraint_,
          update_columns: update_columns,
          where: where
        };
}

function makeInputObjectmission_templates_on_conflict(constraint_, update_columns, where, param) {
  return {
          constraint: constraint_,
          update_columns: update_columns,
          where: where
        };
}

function makeInputObjectcustom_word_list_assignments_on_conflict(constraint_, update_columns, where, param) {
  return {
          constraint: constraint_,
          update_columns: update_columns,
          where: where
        };
}

function makeInputObjectmy_words_best_scores_by_game_arr_rel_insert_input(data, param) {
  return {
          data: data
        };
}

function makeInputObjectmy_words_best_scores_by_game_insert_input(attempts, correct, count, customWordListId, gameKind, userId, param) {
  return {
          attempts: attempts,
          correct: correct,
          count: count,
          customWordListId: customWordListId,
          gameKind: gameKind,
          userId: userId
        };
}

function makeInputObjectlist_words_arr_rel_insert_input(data, on_conflict, param) {
  return {
          data: data,
          on_conflict: on_conflict
        };
}

function makeInputObjectlist_words_insert_input(createdAt, customWordListId, custom_word_list, name, updatedAt, userId, wordId, param) {
  return {
          createdAt: createdAt,
          customWordListId: customWordListId,
          custom_word_list: custom_word_list,
          name: name,
          updatedAt: updatedAt,
          userId: userId,
          wordId: wordId
        };
}

function makeInputObjectlist_words_on_conflict(constraint_, update_columns, where, param) {
  return {
          constraint: constraint_,
          update_columns: update_columns,
          where: where
        };
}

function makeInputObjectcustom_word_lists_on_conflict(constraint_, update_columns, where, param) {
  return {
          constraint: constraint_,
          update_columns: update_columns,
          where: where
        };
}

function makeInputObjectmy_words_attempts_on_conflict(constraint_, update_columns, where, param) {
  return {
          constraint: constraint_,
          update_columns: update_columns,
          where: where
        };
}

function makeInputObjectmy_words_attempts_bool_exp(_and, _not, _or, attempt, customWordListId, list, studentActivityAttemptId, param) {
  return {
          _and: _and,
          _not: _not,
          _or: _or,
          attempt: attempt,
          customWordListId: customWordListId,
          list: list,
          studentActivityAttemptId: studentActivityAttemptId
        };
}

function makeInputObjectstudent_activity_attempts_bool_exp(_and, _not, _or, complete, completedAt, createdAt, gameKind, id, myWordsAttempt, responses, updatedAt, userId, param) {
  return {
          _and: _and,
          _not: _not,
          _or: _or,
          complete: complete,
          completedAt: completedAt,
          createdAt: createdAt,
          gameKind: gameKind,
          id: id,
          myWordsAttempt: myWordsAttempt,
          responses: responses,
          updatedAt: updatedAt,
          userId: userId
        };
}

function makeInputObjectstudent_question_responses_bool_exp(_and, _not, _or, answer, attempt, attemptedAt, id, points, questionIndex, state, studentActivityAttemptId, param) {
  return {
          _and: _and,
          _not: _not,
          _or: _or,
          answer: answer,
          attempt: attempt,
          attemptedAt: attemptedAt,
          id: id,
          points: points,
          questionIndex: questionIndex,
          state: state,
          studentActivityAttemptId: studentActivityAttemptId
        };
}

function makeInputObjecttimestamp_comparison_exp(_eq, _gt, _gte, _in, _is_null, _lt, _lte, _neq, _nin, param) {
  return {
          _eq: _eq,
          _gt: _gt,
          _gte: _gte,
          _in: _in,
          _is_null: _is_null,
          _lt: _lt,
          _lte: _lte,
          _neq: _neq,
          _nin: _nin
        };
}

function makeInputObjectstudent_question_responses_arr_rel_insert_input(data, on_conflict, param) {
  return {
          data: data,
          on_conflict: on_conflict
        };
}

function makeInputObjectstudent_question_responses_on_conflict(constraint_, update_columns, where, param) {
  return {
          constraint: constraint_,
          update_columns: update_columns,
          where: where
        };
}

function makeInputObjectstudent_activity_attempts_on_conflict(constraint_, update_columns, where, param) {
  return {
          constraint: constraint_,
          update_columns: update_columns,
          where: where
        };
}

var QuestionResponsesMutation_inner = {
  Raw: Raw$2,
  query: query$2,
  parse: parse$2,
  serialize: serialize$2,
  serializeVariables: serializeVariables$2,
  serializeInputObjectstudent_question_responses_insert_input: serializeInputObjectstudent_question_responses_insert_input,
  serializeInputObjectstudent_activity_attempts_obj_rel_insert_input: serializeInputObjectstudent_activity_attempts_obj_rel_insert_input,
  serializeInputObjectstudent_activity_attempts_insert_input: serializeInputObjectstudent_activity_attempts_insert_input,
  serializeInputObjectmy_words_attempts_obj_rel_insert_input: serializeInputObjectmy_words_attempts_obj_rel_insert_input,
  serializeInputObjectmy_words_attempts_insert_input: serializeInputObjectmy_words_attempts_insert_input,
  serializeInputObjectcustom_word_lists_obj_rel_insert_input: serializeInputObjectcustom_word_lists_obj_rel_insert_input,
  serializeInputObjectcustom_word_lists_insert_input: serializeInputObjectcustom_word_lists_insert_input,
  serializeInputObjectcustom_word_list_assignments_arr_rel_insert_input: serializeInputObjectcustom_word_list_assignments_arr_rel_insert_input,
  serializeInputObjectcustom_word_list_assignments_insert_input: serializeInputObjectcustom_word_list_assignments_insert_input,
  serializeInputObjectmission_templates_obj_rel_insert_input: serializeInputObjectmission_templates_obj_rel_insert_input,
  serializeInputObjectmission_templates_insert_input: serializeInputObjectmission_templates_insert_input,
  serializeInputObjectactivity_templates_arr_rel_insert_input: serializeInputObjectactivity_templates_arr_rel_insert_input,
  serializeInputObjectactivity_templates_insert_input: serializeInputObjectactivity_templates_insert_input,
  serializeInputObjectactivity_templates_on_conflict: serializeInputObjectactivity_templates_on_conflict,
  serializeInputObjectactivity_templates_bool_exp: serializeInputObjectactivity_templates_bool_exp,
  serializeInputObjecttimestamptz_comparison_exp: serializeInputObjecttimestamptz_comparison_exp,
  serializeInputObjectuuid_comparison_exp: serializeInputObjectuuid_comparison_exp,
  serializeInputObjectString_comparison_exp: serializeInputObjectString_comparison_exp,
  serializeInputObjectmission_templates_bool_exp: serializeInputObjectmission_templates_bool_exp,
  serializeInputObjectcustom_word_list_assignments_bool_exp: serializeInputObjectcustom_word_list_assignments_bool_exp,
  serializeInputObjectcustom_word_lists_bool_exp: serializeInputObjectcustom_word_lists_bool_exp,
  serializeInputObjectBoolean_comparison_exp: serializeInputObjectBoolean_comparison_exp,
  serializeInputObjectmy_words_best_scores_by_game_bool_exp: serializeInputObjectmy_words_best_scores_by_game_bool_exp,
  serializeInputObjectbigint_comparison_exp: serializeInputObjectbigint_comparison_exp,
  serializeInputObjectInt_comparison_exp: serializeInputObjectInt_comparison_exp,
  serializeInputObjectcustom_word_lists_status_enum_comparison_exp: serializeInputObjectcustom_word_lists_status_enum_comparison_exp,
  serializeInputObjectlist_words_bool_exp: serializeInputObjectlist_words_bool_exp,
  serializeInputObjectmission_strands_bool_exp: serializeInputObjectmission_strands_bool_exp,
  serializeInputObjectmission_strands_obj_rel_insert_input: serializeInputObjectmission_strands_obj_rel_insert_input,
  serializeInputObjectmission_strands_insert_input: serializeInputObjectmission_strands_insert_input,
  serializeInputObjectmission_strands_on_conflict: serializeInputObjectmission_strands_on_conflict,
  serializeInputObjectmission_templates_on_conflict: serializeInputObjectmission_templates_on_conflict,
  serializeInputObjectcustom_word_list_assignments_on_conflict: serializeInputObjectcustom_word_list_assignments_on_conflict,
  serializeInputObjectmy_words_best_scores_by_game_arr_rel_insert_input: serializeInputObjectmy_words_best_scores_by_game_arr_rel_insert_input,
  serializeInputObjectmy_words_best_scores_by_game_insert_input: serializeInputObjectmy_words_best_scores_by_game_insert_input,
  serializeInputObjectlist_words_arr_rel_insert_input: serializeInputObjectlist_words_arr_rel_insert_input,
  serializeInputObjectlist_words_insert_input: serializeInputObjectlist_words_insert_input,
  serializeInputObjectlist_words_on_conflict: serializeInputObjectlist_words_on_conflict,
  serializeInputObjectcustom_word_lists_on_conflict: serializeInputObjectcustom_word_lists_on_conflict,
  serializeInputObjectmy_words_attempts_on_conflict: serializeInputObjectmy_words_attempts_on_conflict,
  serializeInputObjectmy_words_attempts_bool_exp: serializeInputObjectmy_words_attempts_bool_exp,
  serializeInputObjectstudent_activity_attempts_bool_exp: serializeInputObjectstudent_activity_attempts_bool_exp,
  serializeInputObjectstudent_question_responses_bool_exp: serializeInputObjectstudent_question_responses_bool_exp,
  serializeInputObjecttimestamp_comparison_exp: serializeInputObjecttimestamp_comparison_exp,
  serializeInputObjectstudent_question_responses_arr_rel_insert_input: serializeInputObjectstudent_question_responses_arr_rel_insert_input,
  serializeInputObjectstudent_question_responses_on_conflict: serializeInputObjectstudent_question_responses_on_conflict,
  serializeInputObjectstudent_activity_attempts_on_conflict: serializeInputObjectstudent_activity_attempts_on_conflict,
  makeVariables: makeVariables$2,
  makeInputObjectstudent_question_responses_insert_input: makeInputObjectstudent_question_responses_insert_input,
  makeInputObjectstudent_activity_attempts_obj_rel_insert_input: makeInputObjectstudent_activity_attempts_obj_rel_insert_input,
  makeInputObjectstudent_activity_attempts_insert_input: makeInputObjectstudent_activity_attempts_insert_input,
  makeInputObjectmy_words_attempts_obj_rel_insert_input: makeInputObjectmy_words_attempts_obj_rel_insert_input,
  makeInputObjectmy_words_attempts_insert_input: makeInputObjectmy_words_attempts_insert_input,
  makeInputObjectcustom_word_lists_obj_rel_insert_input: makeInputObjectcustom_word_lists_obj_rel_insert_input,
  makeInputObjectcustom_word_lists_insert_input: makeInputObjectcustom_word_lists_insert_input,
  makeInputObjectcustom_word_list_assignments_arr_rel_insert_input: makeInputObjectcustom_word_list_assignments_arr_rel_insert_input,
  makeInputObjectcustom_word_list_assignments_insert_input: makeInputObjectcustom_word_list_assignments_insert_input,
  makeInputObjectmission_templates_obj_rel_insert_input: makeInputObjectmission_templates_obj_rel_insert_input,
  makeInputObjectmission_templates_insert_input: makeInputObjectmission_templates_insert_input,
  makeInputObjectactivity_templates_arr_rel_insert_input: makeInputObjectactivity_templates_arr_rel_insert_input,
  makeInputObjectactivity_templates_insert_input: makeInputObjectactivity_templates_insert_input,
  makeInputObjectactivity_templates_on_conflict: makeInputObjectactivity_templates_on_conflict,
  makeInputObjectactivity_templates_bool_exp: makeInputObjectactivity_templates_bool_exp,
  makeInputObjecttimestamptz_comparison_exp: makeInputObjecttimestamptz_comparison_exp,
  makeInputObjectuuid_comparison_exp: makeInputObjectuuid_comparison_exp,
  makeInputObjectString_comparison_exp: makeInputObjectString_comparison_exp,
  makeInputObjectmission_templates_bool_exp: makeInputObjectmission_templates_bool_exp,
  makeInputObjectcustom_word_list_assignments_bool_exp: makeInputObjectcustom_word_list_assignments_bool_exp,
  makeInputObjectcustom_word_lists_bool_exp: makeInputObjectcustom_word_lists_bool_exp,
  makeInputObjectBoolean_comparison_exp: makeInputObjectBoolean_comparison_exp,
  makeInputObjectmy_words_best_scores_by_game_bool_exp: makeInputObjectmy_words_best_scores_by_game_bool_exp,
  makeInputObjectbigint_comparison_exp: makeInputObjectbigint_comparison_exp,
  makeInputObjectInt_comparison_exp: makeInputObjectInt_comparison_exp,
  makeInputObjectcustom_word_lists_status_enum_comparison_exp: makeInputObjectcustom_word_lists_status_enum_comparison_exp,
  makeInputObjectlist_words_bool_exp: makeInputObjectlist_words_bool_exp,
  makeInputObjectmission_strands_bool_exp: makeInputObjectmission_strands_bool_exp,
  makeInputObjectmission_strands_obj_rel_insert_input: makeInputObjectmission_strands_obj_rel_insert_input,
  makeInputObjectmission_strands_insert_input: makeInputObjectmission_strands_insert_input,
  makeInputObjectmission_strands_on_conflict: makeInputObjectmission_strands_on_conflict,
  makeInputObjectmission_templates_on_conflict: makeInputObjectmission_templates_on_conflict,
  makeInputObjectcustom_word_list_assignments_on_conflict: makeInputObjectcustom_word_list_assignments_on_conflict,
  makeInputObjectmy_words_best_scores_by_game_arr_rel_insert_input: makeInputObjectmy_words_best_scores_by_game_arr_rel_insert_input,
  makeInputObjectmy_words_best_scores_by_game_insert_input: makeInputObjectmy_words_best_scores_by_game_insert_input,
  makeInputObjectlist_words_arr_rel_insert_input: makeInputObjectlist_words_arr_rel_insert_input,
  makeInputObjectlist_words_insert_input: makeInputObjectlist_words_insert_input,
  makeInputObjectlist_words_on_conflict: makeInputObjectlist_words_on_conflict,
  makeInputObjectcustom_word_lists_on_conflict: makeInputObjectcustom_word_lists_on_conflict,
  makeInputObjectmy_words_attempts_on_conflict: makeInputObjectmy_words_attempts_on_conflict,
  makeInputObjectmy_words_attempts_bool_exp: makeInputObjectmy_words_attempts_bool_exp,
  makeInputObjectstudent_activity_attempts_bool_exp: makeInputObjectstudent_activity_attempts_bool_exp,
  makeInputObjectstudent_question_responses_bool_exp: makeInputObjectstudent_question_responses_bool_exp,
  makeInputObjecttimestamp_comparison_exp: makeInputObjecttimestamp_comparison_exp,
  makeInputObjectstudent_question_responses_arr_rel_insert_input: makeInputObjectstudent_question_responses_arr_rel_insert_input,
  makeInputObjectstudent_question_responses_on_conflict: makeInputObjectstudent_question_responses_on_conflict,
  makeInputObjectstudent_activity_attempts_on_conflict: makeInputObjectstudent_activity_attempts_on_conflict
};

var include$2 = ApolloClient__React_Hooks_UseMutation.Extend({
      query: query$2,
      Raw: Raw$2,
      parse: parse$2,
      serialize: serialize$2,
      serializeVariables: serializeVariables$2
    });

var use$2 = include$2.use;

var QuestionResponsesMutation_useWithVariables = include$2.useWithVariables;

var QuestionResponsesMutation = {
  QuestionResponsesMutation_inner: QuestionResponsesMutation_inner,
  Raw: Raw$2,
  query: query$2,
  parse: parse$2,
  serialize: serialize$2,
  serializeVariables: serializeVariables$2,
  serializeInputObjectstudent_question_responses_insert_input: serializeInputObjectstudent_question_responses_insert_input,
  serializeInputObjectstudent_activity_attempts_obj_rel_insert_input: serializeInputObjectstudent_activity_attempts_obj_rel_insert_input,
  serializeInputObjectstudent_activity_attempts_insert_input: serializeInputObjectstudent_activity_attempts_insert_input,
  serializeInputObjectmy_words_attempts_obj_rel_insert_input: serializeInputObjectmy_words_attempts_obj_rel_insert_input,
  serializeInputObjectmy_words_attempts_insert_input: serializeInputObjectmy_words_attempts_insert_input,
  serializeInputObjectcustom_word_lists_obj_rel_insert_input: serializeInputObjectcustom_word_lists_obj_rel_insert_input,
  serializeInputObjectcustom_word_lists_insert_input: serializeInputObjectcustom_word_lists_insert_input,
  serializeInputObjectcustom_word_list_assignments_arr_rel_insert_input: serializeInputObjectcustom_word_list_assignments_arr_rel_insert_input,
  serializeInputObjectcustom_word_list_assignments_insert_input: serializeInputObjectcustom_word_list_assignments_insert_input,
  serializeInputObjectmission_templates_obj_rel_insert_input: serializeInputObjectmission_templates_obj_rel_insert_input,
  serializeInputObjectmission_templates_insert_input: serializeInputObjectmission_templates_insert_input,
  serializeInputObjectactivity_templates_arr_rel_insert_input: serializeInputObjectactivity_templates_arr_rel_insert_input,
  serializeInputObjectactivity_templates_insert_input: serializeInputObjectactivity_templates_insert_input,
  serializeInputObjectactivity_templates_on_conflict: serializeInputObjectactivity_templates_on_conflict,
  serializeInputObjectactivity_templates_bool_exp: serializeInputObjectactivity_templates_bool_exp,
  serializeInputObjecttimestamptz_comparison_exp: serializeInputObjecttimestamptz_comparison_exp,
  serializeInputObjectuuid_comparison_exp: serializeInputObjectuuid_comparison_exp,
  serializeInputObjectString_comparison_exp: serializeInputObjectString_comparison_exp,
  serializeInputObjectmission_templates_bool_exp: serializeInputObjectmission_templates_bool_exp,
  serializeInputObjectcustom_word_list_assignments_bool_exp: serializeInputObjectcustom_word_list_assignments_bool_exp,
  serializeInputObjectcustom_word_lists_bool_exp: serializeInputObjectcustom_word_lists_bool_exp,
  serializeInputObjectBoolean_comparison_exp: serializeInputObjectBoolean_comparison_exp,
  serializeInputObjectmy_words_best_scores_by_game_bool_exp: serializeInputObjectmy_words_best_scores_by_game_bool_exp,
  serializeInputObjectbigint_comparison_exp: serializeInputObjectbigint_comparison_exp,
  serializeInputObjectInt_comparison_exp: serializeInputObjectInt_comparison_exp,
  serializeInputObjectcustom_word_lists_status_enum_comparison_exp: serializeInputObjectcustom_word_lists_status_enum_comparison_exp,
  serializeInputObjectlist_words_bool_exp: serializeInputObjectlist_words_bool_exp,
  serializeInputObjectmission_strands_bool_exp: serializeInputObjectmission_strands_bool_exp,
  serializeInputObjectmission_strands_obj_rel_insert_input: serializeInputObjectmission_strands_obj_rel_insert_input,
  serializeInputObjectmission_strands_insert_input: serializeInputObjectmission_strands_insert_input,
  serializeInputObjectmission_strands_on_conflict: serializeInputObjectmission_strands_on_conflict,
  serializeInputObjectmission_templates_on_conflict: serializeInputObjectmission_templates_on_conflict,
  serializeInputObjectcustom_word_list_assignments_on_conflict: serializeInputObjectcustom_word_list_assignments_on_conflict,
  serializeInputObjectmy_words_best_scores_by_game_arr_rel_insert_input: serializeInputObjectmy_words_best_scores_by_game_arr_rel_insert_input,
  serializeInputObjectmy_words_best_scores_by_game_insert_input: serializeInputObjectmy_words_best_scores_by_game_insert_input,
  serializeInputObjectlist_words_arr_rel_insert_input: serializeInputObjectlist_words_arr_rel_insert_input,
  serializeInputObjectlist_words_insert_input: serializeInputObjectlist_words_insert_input,
  serializeInputObjectlist_words_on_conflict: serializeInputObjectlist_words_on_conflict,
  serializeInputObjectcustom_word_lists_on_conflict: serializeInputObjectcustom_word_lists_on_conflict,
  serializeInputObjectmy_words_attempts_on_conflict: serializeInputObjectmy_words_attempts_on_conflict,
  serializeInputObjectmy_words_attempts_bool_exp: serializeInputObjectmy_words_attempts_bool_exp,
  serializeInputObjectstudent_activity_attempts_bool_exp: serializeInputObjectstudent_activity_attempts_bool_exp,
  serializeInputObjectstudent_question_responses_bool_exp: serializeInputObjectstudent_question_responses_bool_exp,
  serializeInputObjecttimestamp_comparison_exp: serializeInputObjecttimestamp_comparison_exp,
  serializeInputObjectstudent_question_responses_arr_rel_insert_input: serializeInputObjectstudent_question_responses_arr_rel_insert_input,
  serializeInputObjectstudent_question_responses_on_conflict: serializeInputObjectstudent_question_responses_on_conflict,
  serializeInputObjectstudent_activity_attempts_on_conflict: serializeInputObjectstudent_activity_attempts_on_conflict,
  makeVariables: makeVariables$2,
  makeInputObjectstudent_question_responses_insert_input: makeInputObjectstudent_question_responses_insert_input,
  makeInputObjectstudent_activity_attempts_obj_rel_insert_input: makeInputObjectstudent_activity_attempts_obj_rel_insert_input,
  makeInputObjectstudent_activity_attempts_insert_input: makeInputObjectstudent_activity_attempts_insert_input,
  makeInputObjectmy_words_attempts_obj_rel_insert_input: makeInputObjectmy_words_attempts_obj_rel_insert_input,
  makeInputObjectmy_words_attempts_insert_input: makeInputObjectmy_words_attempts_insert_input,
  makeInputObjectcustom_word_lists_obj_rel_insert_input: makeInputObjectcustom_word_lists_obj_rel_insert_input,
  makeInputObjectcustom_word_lists_insert_input: makeInputObjectcustom_word_lists_insert_input,
  makeInputObjectcustom_word_list_assignments_arr_rel_insert_input: makeInputObjectcustom_word_list_assignments_arr_rel_insert_input,
  makeInputObjectcustom_word_list_assignments_insert_input: makeInputObjectcustom_word_list_assignments_insert_input,
  makeInputObjectmission_templates_obj_rel_insert_input: makeInputObjectmission_templates_obj_rel_insert_input,
  makeInputObjectmission_templates_insert_input: makeInputObjectmission_templates_insert_input,
  makeInputObjectactivity_templates_arr_rel_insert_input: makeInputObjectactivity_templates_arr_rel_insert_input,
  makeInputObjectactivity_templates_insert_input: makeInputObjectactivity_templates_insert_input,
  makeInputObjectactivity_templates_on_conflict: makeInputObjectactivity_templates_on_conflict,
  makeInputObjectactivity_templates_bool_exp: makeInputObjectactivity_templates_bool_exp,
  makeInputObjecttimestamptz_comparison_exp: makeInputObjecttimestamptz_comparison_exp,
  makeInputObjectuuid_comparison_exp: makeInputObjectuuid_comparison_exp,
  makeInputObjectString_comparison_exp: makeInputObjectString_comparison_exp,
  makeInputObjectmission_templates_bool_exp: makeInputObjectmission_templates_bool_exp,
  makeInputObjectcustom_word_list_assignments_bool_exp: makeInputObjectcustom_word_list_assignments_bool_exp,
  makeInputObjectcustom_word_lists_bool_exp: makeInputObjectcustom_word_lists_bool_exp,
  makeInputObjectBoolean_comparison_exp: makeInputObjectBoolean_comparison_exp,
  makeInputObjectmy_words_best_scores_by_game_bool_exp: makeInputObjectmy_words_best_scores_by_game_bool_exp,
  makeInputObjectbigint_comparison_exp: makeInputObjectbigint_comparison_exp,
  makeInputObjectInt_comparison_exp: makeInputObjectInt_comparison_exp,
  makeInputObjectcustom_word_lists_status_enum_comparison_exp: makeInputObjectcustom_word_lists_status_enum_comparison_exp,
  makeInputObjectlist_words_bool_exp: makeInputObjectlist_words_bool_exp,
  makeInputObjectmission_strands_bool_exp: makeInputObjectmission_strands_bool_exp,
  makeInputObjectmission_strands_obj_rel_insert_input: makeInputObjectmission_strands_obj_rel_insert_input,
  makeInputObjectmission_strands_insert_input: makeInputObjectmission_strands_insert_input,
  makeInputObjectmission_strands_on_conflict: makeInputObjectmission_strands_on_conflict,
  makeInputObjectmission_templates_on_conflict: makeInputObjectmission_templates_on_conflict,
  makeInputObjectcustom_word_list_assignments_on_conflict: makeInputObjectcustom_word_list_assignments_on_conflict,
  makeInputObjectmy_words_best_scores_by_game_arr_rel_insert_input: makeInputObjectmy_words_best_scores_by_game_arr_rel_insert_input,
  makeInputObjectmy_words_best_scores_by_game_insert_input: makeInputObjectmy_words_best_scores_by_game_insert_input,
  makeInputObjectlist_words_arr_rel_insert_input: makeInputObjectlist_words_arr_rel_insert_input,
  makeInputObjectlist_words_insert_input: makeInputObjectlist_words_insert_input,
  makeInputObjectlist_words_on_conflict: makeInputObjectlist_words_on_conflict,
  makeInputObjectcustom_word_lists_on_conflict: makeInputObjectcustom_word_lists_on_conflict,
  makeInputObjectmy_words_attempts_on_conflict: makeInputObjectmy_words_attempts_on_conflict,
  makeInputObjectmy_words_attempts_bool_exp: makeInputObjectmy_words_attempts_bool_exp,
  makeInputObjectstudent_activity_attempts_bool_exp: makeInputObjectstudent_activity_attempts_bool_exp,
  makeInputObjectstudent_question_responses_bool_exp: makeInputObjectstudent_question_responses_bool_exp,
  makeInputObjecttimestamp_comparison_exp: makeInputObjecttimestamp_comparison_exp,
  makeInputObjectstudent_question_responses_arr_rel_insert_input: makeInputObjectstudent_question_responses_arr_rel_insert_input,
  makeInputObjectstudent_question_responses_on_conflict: makeInputObjectstudent_question_responses_on_conflict,
  makeInputObjectstudent_activity_attempts_on_conflict: makeInputObjectstudent_activity_attempts_on_conflict,
  use: use$2,
  useWithVariables: QuestionResponsesMutation_useWithVariables
};

var QuestionResponses = MutationHook$LiteracyplanetClientFlags.Make({
      Raw: Raw$2,
      use: use$2
    });

function useInsertResponses(param) {
  var match = Curry._1(QuestionResponses.useWithWordMonsterError, "ChecksActivityMutations.useInsertResponses");
  var mutation = match[0];
  var makeResponseObject = function (studentActivityAttemptId, answer, points, questionIndex) {
    return {
            answer: answer,
            attempt: undefined,
            attemptedAt: undefined,
            id: undefined,
            points: points,
            questionIndex: questionIndex,
            state: undefined,
            studentActivityAttemptId: Caml_option.some(studentActivityAttemptId)
          };
  };
  var insert = function (responses) {
    Curry._8(mutation, undefined, undefined, undefined, undefined, undefined, undefined, undefined, {
          responses: responses
        });
    
  };
  return [
          makeResponseObject,
          insert
        ];
}

var Raw$3 = {};

var query$3 = Client.gql(["mutation InsertStudentQuestionResponse($answer: String, $points: Int, $questionIndex: Int, $studentActivityAttemptId: uuid)  {\ninsert_student_question_responses_one(object: {answer: $answer, points: $points, questionIndex: $questionIndex, studentActivityAttemptId: $studentActivityAttemptId})  {\n__typename  \n}\n\n}\n"]);

function parse$3(value) {
  var value$1 = value.insert_student_question_responses_one;
  return {
          insert_student_question_responses_one: !(value$1 == null) ? ({
                __typename: value$1.__typename
              }) : undefined
        };
}

function serialize$3(value) {
  var value$1 = value.insert_student_question_responses_one;
  var insert_student_question_responses_one;
  if (value$1 !== undefined) {
    var value$2 = value$1.__typename;
    insert_student_question_responses_one = {
      __typename: value$2
    };
  } else {
    insert_student_question_responses_one = null;
  }
  return {
          insert_student_question_responses_one: insert_student_question_responses_one
        };
}

function serializeVariables$3(inp) {
  var a = inp.answer;
  var a$1 = inp.points;
  var a$2 = inp.questionIndex;
  var a$3 = inp.studentActivityAttemptId;
  return {
          answer: a !== undefined ? a : undefined,
          points: a$1 !== undefined ? a$1 : undefined,
          questionIndex: a$2 !== undefined ? a$2 : undefined,
          studentActivityAttemptId: a$3 !== undefined ? Caml_option.valFromOption(a$3) : undefined
        };
}

function makeVariables$3(answer, points, questionIndex, studentActivityAttemptId, param) {
  return {
          answer: answer,
          points: points,
          questionIndex: questionIndex,
          studentActivityAttemptId: studentActivityAttemptId
        };
}

function makeDefaultVariables$2(param) {
  return {
          answer: undefined,
          points: undefined,
          questionIndex: undefined,
          studentActivityAttemptId: undefined
        };
}

var QuestionResponseMutation_inner = {
  Raw: Raw$3,
  query: query$3,
  parse: parse$3,
  serialize: serialize$3,
  serializeVariables: serializeVariables$3,
  makeVariables: makeVariables$3,
  makeDefaultVariables: makeDefaultVariables$2
};

var include$3 = ApolloClient__React_Hooks_UseMutation.Extend({
      query: query$3,
      Raw: Raw$3,
      parse: parse$3,
      serialize: serialize$3,
      serializeVariables: serializeVariables$3
    });

var use$3 = include$3.use;

var QuestionResponseMutation_useWithVariables = include$3.useWithVariables;

var QuestionResponseMutation = {
  QuestionResponseMutation_inner: QuestionResponseMutation_inner,
  Raw: Raw$3,
  query: query$3,
  parse: parse$3,
  serialize: serialize$3,
  serializeVariables: serializeVariables$3,
  makeVariables: makeVariables$3,
  makeDefaultVariables: makeDefaultVariables$2,
  use: use$3,
  useWithVariables: QuestionResponseMutation_useWithVariables
};

var QuestionResponse = MutationHook$LiteracyplanetClientFlags.Make({
      Raw: Raw$3,
      use: use$3
    });

function useInsertResponse(param) {
  var match = Curry._1(QuestionResponse.useWithWordMonsterError, "ChecksActivityMutations.useInsertResponse");
  var mutation = match[0];
  var upsertActivityState = useUpsertActivityState(undefined);
  return function (studentActivityAttemptId, answer, points, questionIndex, state) {
    Curry._8(mutation, undefined, undefined, undefined, undefined, undefined, undefined, undefined, {
          answer: answer,
          points: points,
          questionIndex: questionIndex,
          studentActivityAttemptId: Caml_option.some(studentActivityAttemptId)
        });
    if (Belt_Option.isSome(state)) {
      return Curry._2(upsertActivityState, studentActivityAttemptId, state);
    }
    
  };
}

var Raw$4 = {};

var query$4 = Client.gql(["mutation MarkComplete($studentActivityAttemptId: uuid, $assignationId: uuid)  {\nupdate_student_activity_attempts(where: {id: {_eq: $studentActivityAttemptId}}, _set: {complete: true})  {\n__typename  \naffected_rows  \n}\n\nliteracy_checks_mark_student_assignation_complete(args: {assignation_id: $assignationId, student_activity_attempt_id: $studentActivityAttemptId})  {\n__typename  \ncompletedAt  \n}\n\n}\n"]);

function parse$4(value) {
  var value$1 = value.update_student_activity_attempts;
  var value$2 = value.literacy_checks_mark_student_assignation_complete;
  return {
          update_student_activity_attempts: !(value$1 == null) ? ({
                __typename: value$1.__typename,
                affected_rows: value$1.affected_rows
              }) : undefined,
          literacy_checks_mark_student_assignation_complete: value$2.map(function (value) {
                var value$1 = value.completedAt;
                return {
                        __typename: value.__typename,
                        completedAt: !(value$1 == null) ? Caml_option.some(value$1) : undefined
                      };
              })
        };
}

function serialize$4(value) {
  var value$1 = value.literacy_checks_mark_student_assignation_complete;
  var literacy_checks_mark_student_assignation_complete = value$1.map(function (value) {
        var value$1 = value.completedAt;
        var completedAt = value$1 !== undefined ? Caml_option.valFromOption(value$1) : null;
        var value$2 = value.__typename;
        return {
                __typename: value$2,
                completedAt: completedAt
              };
      });
  var value$2 = value.update_student_activity_attempts;
  var update_student_activity_attempts;
  if (value$2 !== undefined) {
    var value$3 = value$2.affected_rows;
    var value$4 = value$2.__typename;
    update_student_activity_attempts = {
      __typename: value$4,
      affected_rows: value$3
    };
  } else {
    update_student_activity_attempts = null;
  }
  return {
          update_student_activity_attempts: update_student_activity_attempts,
          literacy_checks_mark_student_assignation_complete: literacy_checks_mark_student_assignation_complete
        };
}

function serializeVariables$4(inp) {
  var a = inp.studentActivityAttemptId;
  var a$1 = inp.assignationId;
  return {
          studentActivityAttemptId: a !== undefined ? Caml_option.valFromOption(a) : undefined,
          assignationId: a$1 !== undefined ? Caml_option.valFromOption(a$1) : undefined
        };
}

function makeVariables$4(studentActivityAttemptId, assignationId, param) {
  return {
          studentActivityAttemptId: studentActivityAttemptId,
          assignationId: assignationId
        };
}

function makeDefaultVariables$3(param) {
  return {
          studentActivityAttemptId: undefined,
          assignationId: undefined
        };
}

var MarkCompleteMutation_inner = {
  Raw: Raw$4,
  query: query$4,
  parse: parse$4,
  serialize: serialize$4,
  serializeVariables: serializeVariables$4,
  makeVariables: makeVariables$4,
  makeDefaultVariables: makeDefaultVariables$3
};

var include$4 = ApolloClient__React_Hooks_UseMutation.Extend({
      query: query$4,
      Raw: Raw$4,
      parse: parse$4,
      serialize: serialize$4,
      serializeVariables: serializeVariables$4
    });

var use$4 = include$4.use;

var MarkCompleteMutation_useWithVariables = include$4.useWithVariables;

var MarkCompleteMutation = {
  MarkCompleteMutation_inner: MarkCompleteMutation_inner,
  Raw: Raw$4,
  query: query$4,
  parse: parse$4,
  serialize: serialize$4,
  serializeVariables: serializeVariables$4,
  makeVariables: makeVariables$4,
  makeDefaultVariables: makeDefaultVariables$3,
  use: use$4,
  useWithVariables: MarkCompleteMutation_useWithVariables
};

var MarkComplete = MutationHook$LiteracyplanetClientFlags.Make({
      Raw: Raw$4,
      use: use$4
    });

function useMarkComplete(assignationId) {
  var match = Curry._2(MarkComplete.useRetry, "ChecksActivityMutations.useInsertResponse", 3);
  var mutation = match[0];
  return function (studentActivityAttemptId) {
    var r_studentActivityAttemptId = Caml_option.some(studentActivityAttemptId);
    var r_assignationId = Caml_option.some(assignationId);
    var r = {
      studentActivityAttemptId: r_studentActivityAttemptId,
      assignationId: r_assignationId
    };
    return Curry._2(mutation, r, undefined);
  };
}

var decode = Json_decode.string;

export {
  ActivityStateMutation ,
  ActivityState ,
  useUpsertActivityState ,
  InsertAttemptMutation ,
  InsertAttempt ,
  decode ,
  useInsertAttempt ,
  QuestionResponsesMutation ,
  QuestionResponses ,
  useInsertResponses ,
  QuestionResponseMutation ,
  QuestionResponse ,
  useInsertResponse ,
  MarkCompleteMutation ,
  MarkComplete ,
  useMarkComplete ,
  
}
/* query Not a pure module */
